<style>
.edi-detail-bill .detail-bill-footer div.detail-bill-info p.total-p {
    margin: .5em 5px;
    font-size: 1em;
}
.edi-detail-bill ul.detail-bill-sonlist.returnBill li {
    display: inline-block;
    min-width: 50%;
    width: auto;
}
.edi-detail-bill .detail-bill-list-flex {
    display: flex;
    flex-direction: column;
    justify-content: left;
    align-items: inherit;
}
</style>
<template>
	<div class="edi-detail-bill">
		<!-- <div class="filter">
			<input type="text" placeholder="" class="ui-search-input"/>
		</div> -->
		<navbar title="餐企退单-明细"></navbar>
		<div v-show="scrollShow" class="common-scroll detail-scroll">
			<p class="detail-bill-status">订单号：{{returnDetailData.trans_bill_no}}
				<span class="nav-btn" @click="openBillInfo()">
					<img src="../assets/nav-btn.png" alt="">
				</span>
				<span v-if="returnDetailData.bill_state == 20" class="state-grey-font">未确认</span>
				<span v-if="returnDetailData.bill_state == 21" class="state-red-font">已确认</span>
				<span v-if="returnDetailData.bill_state == 29" class="state-grey-font">已退回</span>
			</p>
			<div class="bill-all-info" v-show="billInfoShow">
				<ul class="detail-bill-info-list">
					<li class="detail-bill-fulllist">退货企业：{{returnDetailData.restaurant_name}}</li>
					<li class="detail-bill-fulllist">退货机构：{{returnDetailData.from_organ_name}}</li>
					<li class="detail-bill-fulllist detail-bill-remark">整单备注：{{returnDetailData.remark}}</li>
				</ul>
			</div>
			<div class="detail-bill-wrapper">
				<div class="upload-file-div" v-if="!isZ5 && uploadImgList.length">
					<label>附件资料：</label>
					<upload-img
						:uploadImgList='uploadImgList'
						:imgListLength='6'
						:smallDelIco='smallDelIco'
						:billState='returnDetailData.bill_state'
						:jumpBill='true'
						@attachClick="attachClick"
					></upload-img>
				</div>
				<!-- <h4 class="detail-bill-address">{{returnDetailData.restaurant_name}} - {{returnDetailData.from_organ_name}}</h4> -->
				<ul class="detail-bill-list detail-bill-list-flex">
					<li v-for="returnDetail in returnDetails">
						<div class="returnDetail-title">{{returnDetail.goods_name}}({{returnDetail.goods_unit}})</div>
						<ul class="detail-bill-sonlist returnBill">
							<li class="detail-bill-fulllist" v-if="returnDetail.goods_code" style="width: 100%;">品项编号：{{returnDetail.goods_code}}</li>
							<li v-if="isPesc">规格：{{returnDetail.goods_spec}}</li>
							<li>退货数量：{{returnDetail.goods_num | numFixed(numScale)}}</li>
							<li>退货单价：{{returnDetail.goods_price_send | numFixed(numScale)}} 元</li>
							<li v-show="!returnDetailData.hiddenTax">税率：{{returnDetail.goods_cess}} %</li>
							<li>退货金额：{{returnDetail.sub_total_send | numFixed(numScale)}} 元</li>
							<div v-show="returnDetail.goods_assist_unit">
								<li class="detail-bill-twolist">辅助单位：{{returnDetail.goods_assist_unit}}</li>
								<li class="detail-bill-twolist">退货辅助数量：{{returnDetail.goods_assist_num | numFixed(4)}}</li>
								<!-- <li class="detail-bill-twolist" style="height: 17px"></li> -->
							</div>
						</ul>
					</li>
				</ul>
			</div>
		</div>
		<div v-show="scrollShow" class="detail-bill-footer">
			<div class="detail-else-info" v-show="show">
				<div v-if="sumMoney">
					<p>退货金额：{{ sumMoney }}元</p>
					<p>退货辅助数量：{{sumGoodsAssistNumReturn | numFixed(4)}}</p>
				</div>
				<div v-else>
					<p>退货金额：{{sumSubTotalSend | numFixed(numScale)}}元</p>
					<p>退货辅助数量：{{sumGoodsAssistNumReturn | numFixed(4)}}</p>
				</div>
			</div>
			<div class="detail-bill-info">
				<span class="detail-bill-total-btn" @click="infoExchange">合计</span>
			</div>
			<div v-if="returnDetailData.bill_state == 20" class="detail-bill-return f-right">
				<a @click="agreen(21)">同意</a>
			</div>
			<div v-if="returnDetailData.bill_state == 20" class="detail-bill-red f-right">
				<a @click="refuseB">退回</a>
			</div>
			<div v-if="returnDetailData.bill_state == 21" class="detail-bill-return f-right" style="border-right: solid 1px #fff">
				<a @click="importExcel">Excel</a>
			</div>
		</div>
		<loading v-show="loading"></loading>
		<tips-auto v-show="tipsauto" :tipsFont = "tipsFont"></tips-auto>
		<tips v-show="tips" :btnNum = "btnNum" :tipsFont = "tipsFont" v-on:tipStatus = "tipStatus"></tips>
		<tips v-show="tipsB" :btnNum = "btnNum" :tipsFont = "tipsFont" v-on:tipStatus = "tipStatusB"></tips>
		<tips-t :hasTipsFont="hasTipsFont" :btnFont="btnFont" :tipsFont="tipsFont" ref="tipsTShow" v-on:tipStatus="getStatues"></tips-t>
		<item-img ref="itemImgRef"></item-img>
	</div>
</template>

<script>
import Loading from '../components/loading'
import Tips from '../components/Tips'
import TipsT from '../components/TipsT'
import TipsAuto from '../components/TipsAuto'
import NavBar from '../components/NavBar'
import ItemImg from '../components/ItemImg'
import UploadImg from '../components/Upload'
export default {
	data () {
		return {
			hasTipsFont: true,
			btnFont: ['确定', '取消'],
			isZ5: false,
			smallDelIco: false,
			sumMoney: '',
			scrollShow: false,
			tips: false,
			tipsB: false,
			btnNum: 2,
			loading: true,
			tipsauto: false,
			tipsFont: '',
			numScale: 2,
			sec: 1500,
			returnDetailData: {},
			returnDetails: {},
			queryData: this.$route.query,
			show: false,
			billInfoShow: false,
			isPesc: false, // 是否显示规格的系统参数
			uploadImgList: []
		}
	},
	components: {
		'loading': Loading,
		'tips-auto': TipsAuto,
		'tips': Tips,
		'tips-t': TipsT,
		'navbar': NavBar,
		'item-img': ItemImg,
		'upload-img': UploadImg
	},
	created () {
		this.loading = true
		var filterData = {
			bill_id: this.queryData.bill_id
		}
		this.$http.post('/cldEdi/business/billWithDetail', filterData).then((response) => {
			const forceUploadPermitFlag = (!response.body.otherdata || response.body.otherdata.forceUploadPermitFlag === null) ? false : response.body.otherdata.forceUploadPermitFlag
			this.loading = false
			this.scrollShow = true
			this.isZ5 = response.body.otherdata == null ? false : response.body.otherdata.isZ5

			if (!this.isZ5 && forceUploadPermitFlag === true) {
				this.$fxToast.warning('请上传供货商证照信息！')
				this.$router.replace({path: '/main/my'})
			}
			this.returnDetailData = response.body.data
			this.isPesc = this.returnDetailData.isPesc // 是否显示规格的系统参数
			this.numScale = (this.returnDetailData.number_scale || this.returnDetailData.number_scale === 0) ? this.returnDetailData.number_scale : 2
			this.returnDetails = response.body.data.details
			this.sumMoney = this.returnDetailData.sum_money

			if (!this.isZ5) {
				this.getUploadPost()
			}
		}, (response) => {
			this.loading = false
			this.autoTips('服务请求失败，稍后请重试！')
		})
	},
	methods: {
		tipsTShow (str) {
			// 弹出操作提示框
			this.$refs.tipsTShow.open(str)
		},
		importExcel () {
			// 导出Excel
			// 1、判断邮箱是否绑定
			var val = this.email
			if (val === null) {
				// 未绑定邮箱，提示绑定邮箱
				this.tipsFont = '用户尚未绑定邮箱'
				this.btnFont = ['去绑定', '取消']
				this.tipsTShow('bindEmail')
			} else {
				// 已绑定邮箱，提示将excel发送至绑定邮箱
				this.tipsFont = '将单据导出Excel并发送至绑定邮箱'
				this.btnFont = ['确定', '取消']
				this.tipsTShow('sendEmail')
			}
		},
		getStatues (msg) {
			var temp = []
			temp = msg.split('+')
			switch (temp[0]) {
			case 'bindEmail':
				this.$router.push('/email-bind')
				this.goodsTotalInfo.emailLinksChange = true
				break
			case 'sendEmail':
				this.sendEmail()
				break
			}
		},
		sendEmail () {
			// 对接导出excel并发送邮件接口
			this.loading = true
			var billId = {
				'bill_id': this.queryData.bill_id
			}
			this.$http.post('/cldEdi/business/8001', billId).then((response) => {
				this.loading = false
				var data = response.body
				if (data.result) {
					this.autoTips('邮件发送成功')
				} else {
					this.autoTips(data.message)
				}
			}, (response) => {
				this.loading = false
				this.autoTips('服务请求失败，稍后请重试！')
			})
		},
		sendToWeight () {
			this.loading = true
			this.detailData.weight_state = 1
			return this.$http.post('/cldEdi/business/bill/updateWithDetail', this.detailData).then((response) => {
				this.loading = false
				var data = response.body
				if (!data.result) {
					this.autoTips(data.message)
					return
				}
			}, (response) => {
				this.loading = false
				this.autoTips('服务请求失败，稍后请重试！')
			})
		},
		infoExchange () {
			this.show = !this.show
		},
		tipStatus (msg) {
			this.tips = false
			this.msg = msg
			this.refuseBack()
		},
		tipStatusB (msg) {
			this.tipsB = false
			this.msg = msg
			if (this.msg[1] === true) {
				this.refuse()
				return false
			}
		},
		autoTips (msg) {
			var self = this
			self.tipsauto = true
			self.tipsFont = msg
			setTimeout(() => {
				self.tipsauto = false
			}, self.sec)
		},
		agreen (state) {
			this.loading = true
			var updateData = {
				bill_state: state,
				id: this.returnDetailData.id
			}
			this.$http.post('/cldEdi/business/bill/updateBillState', updateData).then((response) => {
				this.loading = false
				var data = response.body
				if (data.result) {
					this.returnDetailData.bill_state = state
					this.autoTips('退单已确认')
				}
			}, (response) => {
				this.loading = false
				this.autoTips('服务请求失败，稍后请重试！')
			})
		},
		refuse () {
			this.tips = true
			this.tipsFont = '确认退回订单？'
		},
		refuseB () {
			this.tipsB = true
			this.tipsFont = '退单退回后将不可撤销，是否继续？'
		},
		refuseBack () {
			if (this.msg[1]) {
				this.loading = true
				var updateData = {
					bill_state: 29,
					id: this.returnDetailData.id
				}
				this.$http.post('/cldEdi/business/bill/updateBillState', updateData).then((response) => {
					this.loading = false
					var self = this
					var data = response.body
					if (data.result) {
						this.returnDetailData.bill_state = 29
						this.autoTips('退单已退回')
						setTimeout(function () {
							self.$router.go(-1)
						}, 1500)
					}
				}, (response) => {
					this.loading = false
					this.autoTips('服务请求失败，稍后请重试！')
				})
			} else {
				return false
			}
		},
		openBillInfo () {
			this.billInfoShow = !this.billInfoShow
		},
		// 获取附件列表
		getUploadPost () {
			this.$http.post('/cldEdi/business/bill/showEnclosure', {id: this.queryData.bill_id}).then((response) => {
				var data = response.body
				if (data.result) {
					this.uploadImgList = data.data
				} else {
					this.autoTips(data.message)
				}
			}, (response) => {
				this.loading = false
				this.autoTips('服务请求失败，稍后请重试！')
			})
		},
		/* 点击预览图片 */
		attachClick (url) {
			this.$refs.itemImgRef.open(url)
		}
	},
	filters: {
		// edi小数位数处理
		numFixed (val, scale) {
			// if (scale) {
			// 	return val.toFixed(scale)
			// } else {
			return val
			// }
		}
	},
	computed: {
		sumSubTotalSend () {
			let sumSubTotalSend = 0
			if (this.returnDetails) {
				for (let i = 0; i < this.returnDetails.length; i++) {
					sumSubTotalSend += this.returnDetails[i].sub_total_send
				}
			}
			sumSubTotalSend = parseFloat((sumSubTotalSend).toFixed(2))
			return sumSubTotalSend
		},
		sumGoodsAssistNumReturn () {
			let sumGoodsAssistNumReturn = 0
			if (this.returnDetails) {
				for (let i = 0; i < this.returnDetails.length; i++) {
					sumGoodsAssistNumReturn += this.returnDetails[i].goods_assist_num
				}
			}
			return sumGoodsAssistNumReturn
		}
	}
}
</script>



// WEBPACK FOOTER //
// DetailReturnBill.vue?65e7b0ee